<template>
  <CRow>
    <CCol col="12" xl="8">
      <CButton size="sm" color="info" style="margin-bottom:10px;" @click="back()">Back</CButton>
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Reps for CSR
          <!-- <CButton size="sm" style="float:right;" color="success" @click="addRep()">Add Rep To CSR</CButton> -->
        </CCardHeader>
        <CCardBody v-if="user_info">
          <label>CSR: {{user_info.name}}</label><br />
          <label>Email: {{user_info.email}}</label><br /><br />
          <div style="width:420px;margin-left:auto;margin-right:auto;margin-bottom:15px;padding-bottom:30px;">
            <v-select style="width:300px;float:left;" placeholder="Select Rep To Add" v-if="repOptions" v-model="rep_selected" :options="repOptions" label="name"></v-select>
            <button class="btn-sm btn-success" style="float:left;width:100px;" @click="addRep()">Add Rep</button>
          </div>
          <CDataTable
            :items="data"
            :fields="fields"
            column-filter
            table-filter
            sort
            v-if="!addRepLoading"
          >
          <template #action="{item, index}">
            <td>
              <CButton size="sm" color="danger" @click="remove( item, index )">Remove</CButton>
            </td>
          </template>
        </CDataTable>
        <small-loader v-else></small-loader>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import 'vue-select/dist/vue-select.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
var methods = {}

methods.getUserInfo = function () {
  axios.get(this.$apiAdress + '/api/getUserInfo/' + this.csr_id + '?token=' + localStorage.getItem('api_token'))
  .then(response => {
    this.user_info = response.data
  })
}

methods.back = function () {
  this.$router.push('/csr_users_table')
}

methods.getUsers = function () {
  const postData = {
    csr_id: this.csr_id
  }
  axios.post(this.$apiAdress +'/api/getCsrReps?token=' + localStorage.getItem('api_token'), postData)
  .then(response => {
    console.log(response)
    this.data = response.data
  }).catch(e => {
    console.log(e)
  })
}

methods.addRep = function () {
  if (this.rep_selected) {
    this.addRepLoading = true
    const postData = {
      csr_id: this.csr_id,
      rep: this.rep_selected
    }
    axios.post(this.$apiAdress + '/api/addRepToCsr?token='+localStorage.getItem('api_token'), postData)
    .then(response => {
      this.data.push(this.rep_selected)
      this.rep_selected = ''
      this.addRepLoading = false
    })
  }
}

methods.remove = function (item, index) {
  const postData = {
    csr_id: this.csr_id,
    rep: item
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/removeRepToCsr?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.data.splice(index, 1)
  })
}

methods.getAllReps = function () {
  axios.get(this.$apiAdress + '/api/getAllReps?token=' + localStorage.getItem('api_token'))
  .then(response => {
    console.log(response)
    this.repOptions = response.data
  })
}

methods.showRepList = function (id) {

}

export default {
  name: 'CsrRepList',
  props: ['csr_id'],
  data() {
    return {
      data: [],
      fields: ['id', 'name', 'email', 'rep_number', 'action'],
      currentPage: 1,
      user_info: null,
      rep_selected: '',
      repOptions: null,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addRepLoading: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getUsers();
    this.getUserInfo()
    this.getAllReps()
  }
}
</script>
